export default __webpack_public_path__ + "static/media/iconNoCB.6c520b16.png";